declare namespace $ {

	export class $mol_icon_web extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=web.view.tree.d.ts.map